import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { bhpButtonSx } from "../../styles/bhpStyles";


type ConfirmationDialogProps = {

    dialogOpen: boolean;
    handleCancel: () => void;
    handleOk: () => void;
    text: string;

};


export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ( props: ConfirmationDialogProps ) => {

    const { dialogOpen, handleCancel, handleOk, text } = props;
    
    return (

        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
            maxWidth="xs"
            open={dialogOpen}>
            <DialogTitle>Confirmation</DialogTitle>
            <DialogContent dividers>
                {text}
            </DialogContent>
            <DialogActions>
                <Button onClick={ handleOk } sx={{ ...bhpButtonSx, width: '100px' }}>
                    Ok
                </Button>
                <Button autoFocus onClick={ handleCancel } sx={{ ...bhpButtonSx, width: '100px' }}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>

    );


};